// generated by genversion
export const version = "1.3.0";
